import { store } from "../store";
import { setLoading } from "../slice/loaderSlice";
import { toast } from "react-toastify";

export async function API(url, header, method, obj) {
  try {
    store.dispatch(setLoading(true));
    const result = await fetch(`${process.env.REACT_APP_BASE_URL}` + url, {
      method: method,
      headers: header,
      body: obj != null ? JSON.stringify(obj) : obj,
    });
    const responseData = await result.json();
    if (responseData?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    if (responseData) {
      store.dispatch(setLoading(false));
    }
    return responseData;
  } catch (error) {
    console.error("API error catch", error);
    // ponytail: surface network/CORS failures instead of rendering empty tables silently
    toast.error(`Cannot reach API (${process.env.REACT_APP_BASE_URL}${url}): ${error.message}`, { toastId: "api-error" });
    store.dispatch(setLoading(false));
  }
}

export async function ImageAPI(url, header, method, obj) {
  try {
    store.dispatch(setLoading(true));
    const result = await fetch(`${process.env.REACT_APP_BASE_URL}` + url, {
      method: method,
      headers: header,
      body: obj,
    });
    const responseData = await result.json();
    if (responseData?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    if (responseData) {
      store.dispatch(setLoading(false));
    }
    return responseData;
  } catch (error) {
    console.error("error in the Image APi", error);
    toast.error(`Cannot reach API (${process.env.REACT_APP_BASE_URL}${url}): ${error.message}`, { toastId: "api-error" });
    store.dispatch(setLoading(false));
  }
}
